const getBase64 = async (file) => {
    const promise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = async () => {
            resolve(reader.result);
        };
    })
    const image = await promise; // Wait for the promise to resolve
    return image;
}

export const getPreviewUrl = async (file) => {
    if (!file.filePath && !file.preview) {
        file.preview = await getBase64(file.file);
    }
    // console.log('file.preview', file.preview)
    return file.filePath || file.preview
};